import { useState } from 'react';
import { ShoppingCart, Signpost } from 'lucide-react';
import './CavemanHouseScene.css';

export function CavemanHouseScene({ gameState, onDismiss }) {
  const [dismissed, setDismissed] = useState(false);
  const dismiss = () => {
    if (onDismiss) onDismiss();
    else setDismissed(true);
  };
  if (dismissed && !onDismiss) return null;
  return (
    <div className="caveman-overlay" role="dialog" aria-modal="true" aria-labelledby="caveman-title">
      <section className="caveman-frame">
        <div className="caveman-art-wrap">
          <img src="./scenes/dave-the-caveman.webp" alt="Dave the Caveman outside his rough Lakehead house" />
        </div>
        <div className="caveman-panel">
          <span className="scene-kicker">LAKEHEAD · BACKROADS ONLY</span>
          <h2 id="caveman-title">Dave the Caveman</h2>
          <p>You got lost badly enough to find Dave. Nobody puts this address on a map, and Dave considers measuring a bag to be more of a suggestion than a rule.</p>
          <div className="caveman-warning"><strong>BUYER BEWARE</strong><span>Dave has a 40% chance to short any purchase — even bud. You still pay full price.</span></div>
          <div className="caveman-actions">
            <button onClick={dismiss}><ShoppingCart /><span><strong>Deal with Dave</strong><small>Open the existing Caveman market</small></span></button>
            <button onClick={dismiss}><Signpost /><span><strong>Find the road out</strong><small>Use Travel to escape to a destination you actually qualify for</small></span></button>
          </div>
          <small className="caveman-day">Day {Number(gameState?.day || 1)} · Caveman’s House remains hidden from the normal map.</small>
        </div>
      </section>
    </div>
  );
}
